"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyOwnerAdminDto = instanceOfPropertyOwnerAdminDto;
exports.PropertyOwnerAdminDtoFromJSON = PropertyOwnerAdminDtoFromJSON;
exports.PropertyOwnerAdminDtoFromJSONTyped = PropertyOwnerAdminDtoFromJSONTyped;
exports.PropertyOwnerAdminDtoToJSON = PropertyOwnerAdminDtoToJSON;
exports.PropertyOwnerAdminDtoToJSONTyped = PropertyOwnerAdminDtoToJSONTyped;
/**
 * Check if a given object implements the PropertyOwnerAdminDto interface.
 */
function instanceOfPropertyOwnerAdminDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fullName' in value) || value['fullName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function PropertyOwnerAdminDtoFromJSON(json) {
    return PropertyOwnerAdminDtoFromJSONTyped(json, false);
}
function PropertyOwnerAdminDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fullName': json['fullName'],
        'email': json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phone': json['phone'] == null ? undefined : json['phone'],
    };
}
function PropertyOwnerAdminDtoToJSON(json) {
    return PropertyOwnerAdminDtoToJSONTyped(json, false);
}
function PropertyOwnerAdminDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'phone': value['phone'],
    };
}
